module.exports = __webpack_public_path__ + "static/04-cd86fda9a32f0224af2e31c57c6dc498.jpg";